import React, { useState } from "react";
import { useHistory } from "react-router";

import styled from "styled-components/macro";

const Main = styled.main`
  height: 100%;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  font-family: "Bowlby One SC", cursive;
  font-size: 3rem;
  color: #f06595;

  margin: 0 0 1rem 0;
`;

const InputContainer = styled.div`
  font-size: 2rem;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;

  margin: 1rem 0;

  color: #adb5bd;
`;

const InputForm = styled.div`
  margin: 1.5rem 0;
`;

const FromTo = styled.div`
  margin: 0.5rem 0;

  display: flex;
  align-items: center;
`;

const NumberInput = styled.input`
  width: 90px;

  font-size: 2.5rem;
  font-weight: bold;

  text-align: center;
  color: #495057;

  margin: 0 0.8rem;
  padding: 0.3rem 1rem;

  border: 1px solid #dee2e6;
  background-color: #f1f3f5;
  border-radius: 5px;
`;

const StartButton = styled.button`
  cursor: pointer;

  font-size: 1.5rem;
  padding: 0.7rem 2rem;
  border-radius: 5px;

  background-color: #f783ac;
  border: none;
  color: white;
`;

export default function HomePage() {
  const defaultRange = { from: 1, to: 50 };
  const [range, setRange] = useState(defaultRange);
  const [limit, setLimit] = useState(100);

  const history = useHistory();

  function onStart() {
    if (
      !isNaN(range.from) &&
      !isNaN(range.to) &&
      !isNaN(limit) &&
      range.from >= 1 &&
      range.to <= 150 &&
      range.from <= range.to &&
      limit >= 50
    )
      history.push("/quiz", { range, limit });
  }

  return (
    <Main>
      <Title>VITA, 300!</Title>

      <InputForm>
        <InputContainer>
          <FromTo>
            <NumberInput
              type="input"
              defaultValue={defaultRange.from}
              onChange={(e) =>
                setRange({ from: Number(e.target.value), to: range.to })
              }
            />
            번 부터
          </FromTo>
          <FromTo>
            <NumberInput
              type="input"
              defaultValue={defaultRange.to}
              onChange={(e) =>
                setRange({ to: Number(e.target.value), from: range.from })
              }
            />
            번 까지
          </FromTo>
        </InputContainer>
        <InputContainer>
          길이 제한
          <NumberInput
            type="input"
            defaultValue={limit}
            onChange={(e) => setLimit(Number(e.target.value))}
          />
          자
        </InputContainer>
      </InputForm>

      <StartButton onClick={onStart}>시작하기</StartButton>
    </Main>
  );
}
